import "core-js/modules/es6.promise";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import LambdaApiService from '../../../../services/apiService/lambda';
import NiotaClassicApiService from '../../../../services/niotaClassicApiService';
import formMixin from '../../formMixin';
import parserTypesMixin from './typesMixin';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
export default {
  name: 'NiotaClassicDevicetypesPacketParserPayloadTest',
  mixins: [formMixin, parserTypesMixin],
  props: {
    parserConfig: {
      type: Object,
      required: true
    },
    parserType: {
      type: String,
      required: true
    },
    accountId: {
      type: Number,
      required: true
    },
    customTestFunction: {
      type: Function,
      requirded: false,
      default: null
    }
  },
  data: function data() {
    return {
      parserTestFormIsValid: false,
      parserTestData: {
        loraFramePort: 1,
        payloadType: 'HEX'
      },
      isParsing: false
    };
  },
  computed: {
    payloadHexRule: function payloadHexRule() {
      var _this = this;

      var isJsonPayload = function isJsonPayload(v) {
        if (!v) {
          return false;
        }

        try {
          var parsed = JSON.parse(v); // do not allow simple strings or numbers

          return isArray(parsed) || isObject(parsed);
        } catch (_) {
          return false;
        }
      };

      return this.requiredRule.concat([function (v) {
        return _this.parserTestData.payloadType === 'HEX' && _this.isHexPayload(v) || _this.parserTestData.payloadType === 'JSON' && isJsonPayload(v) || "Must be valid ".concat(_this.parserTestData.payloadType === 'HEX' ? 'Hex-payload' : 'json-array/object');
      }]);
    }
  },
  methods: {
    isHexPayload: function isHexPayload(v) {
      return !!v && v.length % 2 === 0 && /^[a-fA-F0-9]+$/.exec(v) !== null;
    },
    validateForm: function validateForm() {
      this.$refs['parserTestForm'].validate();
    },
    testClassicDeviceTypeParser: function () {
      var _testClassicDeviceTypeParser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload, meta) {
        var hasError, res, accountData, apiKey, parsedRes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                hasError = false;
                _context.prev = 1;
                // https://gitlab.com/digimondo-code/niota-web/-/blob/master/src/services/payloadParser.ts
                res = {
                  data: {}
                };
                _context.next = 5;
                return NiotaClassicApiService.accountsGet(this.accountId);

              case 5:
                accountData = _context.sent;
                apiKey = get(accountData, 'data.account.data.realTimeApiKey');

                if (!apiKey) {
                  _context.next = 13;
                  break;
                }

                _context.next = 10;
                return NiotaClassicApiService.deviceTypesParsePayload({
                  parseConfig: {
                    parser: {
                      config: this.parserConfig,
                      type: this.parserType
                    },
                    payload: payload,
                    meta: meta
                  },
                  api_key: apiKey
                });

              case 10:
                res = _context.sent;
                _context.next = 14;
                break;

              case 13:
                // TODO: error-message, can this happen?
                console.error('Account does not seem to have an API-key', this.accountId, accountData);

              case 14:
                parsedRes = res.data;
                hasError = get(parsedRes, 'result.body.error');

                if (!hasError) {
                  this.parserTestData.response = get(parsedRes, 'result.body.parsed');
                  this.parserTestData = cloneDeep(this.parserTestData);
                }

                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](1);
                console.error('Test-payload parsing failed', get(_context.t0, 'response.data.err', _context.t0));
                hasError = get(_context.t0, 'response.data.err', _context.t0);

              case 23:
                return _context.abrupt("return", hasError);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 19]]);
      }));

      function testClassicDeviceTypeParser(_x, _x2) {
        return _testClassicDeviceTypeParser.apply(this, arguments);
      }

      return testClassicDeviceTypeParser;
    }(),
    testParser: function () {
      var _testParser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var properPayload, meta, hasError, parseTestResult, syntaxError;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                this.isParsing = true;
                properPayload = this.isHexPayload(this.parserTestData.payload) ? this.parserTestData.payload : JSON.parse(this.parserTestData.payload);
                meta = {
                  lora: {
                    fport: parseInt(this.parserTestData.loraFramePort)
                  },
                  device_id: -1,
                  device_type_id: -1
                };
                hasError = false;

                if (!(typeof this.customTestFunction === 'function')) {
                  _context2.next = 19;
                  break;
                }

                _context2.prev = 6;
                _context2.next = 9;
                return this.customTestFunction(properPayload, meta);

              case 9:
                parseTestResult = _context2.sent;
                this.parserTestData.response = parseTestResult.result;
                this.parserTestData = cloneDeep(this.parserTestData);
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](6);
                hasError = _context2.t0.response.data.error;

              case 17:
                _context2.next = 22;
                break;

              case 19:
                _context2.next = 21;
                return this.testClassicDeviceTypeParser(properPayload, meta);

              case 21:
                hasError = _context2.sent;

              case 22:
                if (hasError) {
                  _context2.next = 24;
                  break;
                }

                return _context2.abrupt("return");

              case 24:
                if (!(this.parserType === 'function' && get(this.parserConfig, 'scriptType') === 'javascript')) {
                  _context2.next = 29;
                  break;
                }

                syntaxError = null;
                _context2.next = 28;
                return LambdaApiService.evaluateScript({
                  script: get(this.parserConfig, 'custom_function_js'),
                  scriptParams: [this.parserTestData.payload, {
                    lora: {
                      fport: parseInt(this.parserTestData.loraFramePort)
                    },
                    device_id: -1,
                    device_type_id: -1
                  }]
                }).then(function (res) {
                  syntaxError = get(res, 'syntaxError') || get(res, 'error');
                }).catch(function (error) {
                  console.error(error);
                });

              case 28:
                if (syntaxError) {
                  hasError = syntaxError;
                }

              case 29:
                this.parserTestData.response = hasError;
                this.parserTestData = cloneDeep(this.parserTestData);

              case 31:
                _context2.prev = 31;
                this.isParsing = false;
                return _context2.finish(31);

              case 34:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0,, 31, 34], [6, 14]]);
      }));

      function testParser() {
        return _testParser.apply(this, arguments);
      }

      return testParser;
    }()
  }
};